module.exports = __webpack_public_path__ + "img/bind-pdd-3.30477a7c.png";